import React, { useState } from "react";
import { useAdminTemplates } from "hooks/fetch/useAdminTemplates";
import { useTecimobDepartament } from "hooks/fetch/useDepartament";
import { ContentTable } from "pages/Users/styles";
import { Table } from "styles/Table";
import { LoadingSpinner } from "components/LoadingSpinner";
import { Loading } from "components/ContactsTable/styles";
import { TemplateCard } from "components/TemplateCard";
import styled from "styled-components";
import { FormControl } from "styles/FormControl";

const FilterInput = styled.input`
    min-width: 200px;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ccc;
    background: ${props => props.theme.colors.inputBackground};
    color: ${props => props.theme.colors.text};
`;

const FilterSelect = styled(FormControl).attrs({ as: 'select' })`
    min-width: 180px;
    cursor: pointer;
    background: ${props => props.theme.colors.inputBackground};
    color: ${props => props.theme.colors.text};
` as React.ComponentType<React.SelectHTMLAttributes<HTMLSelectElement>>;

const Filters = styled.div`
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    align-items: center;
    flex-wrap: wrap;
`;

export function TemplatesTable() {
    const { data, isLoading } = useAdminTemplates();
    const { data: departments } = useTecimobDepartament();

    const [titleFilter, setTitleFilter] = useState('');
    const [departmentFilter, setDepartmentFilter] = useState<string>('all');

    const filtered = data?.filter((template) => {
        const matchesTitle = template.title.toLowerCase().includes(titleFilter.toLowerCase());
        const matchesDepartment =
            departmentFilter === 'all' ||
            (departmentFilter === 'null' ? template.department_id === null : template.department_id === departmentFilter);
        return matchesTitle && matchesDepartment;
    });

    return (
        <ContentTable>
            {isLoading && (
                <Loading>
                    <LoadingSpinner size={25} thickness={2} />
                </Loading>
            )}

            {!isLoading && (
                <>
                    <Filters>
                        <FilterInput
                            placeholder="Filtrar por título..."
                            value={titleFilter}
                            onChange={e => setTitleFilter(e.target.value)}
                        />
                        <FilterSelect
                            value={departmentFilter}
                            onChange={(e: any) => setDepartmentFilter(e.target.value)}
                        >
                            <option value="all">Todos os departamentos</option>
                            {departments?.map((dept) => (
                                <option key={dept.id} value={dept.id}>{dept.name}</option>
                            ))}
                        </FilterSelect>
                    </Filters>
                    <Table>
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Mensagem</th>
                                <th>Envio manual</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered && filtered.map((template) => (
                                <TemplateCard key={template.id} template={template} />
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </ContentTable>
    );
}
